import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { mapSpaceValue } from '../../LayoutUtils'
import { SpacerProps } from '../SpacerTypes'

const VerticalSpacer: FunctionComponent<SpacerProps> = ({
    space,
    backgroundColor = 'tahitian-4',
    testID,
}): ReactElement => (
    <Grid
        noExpand
        height={mapSpaceValue(space)}
        backgroundColor={backgroundColor}
        testID={testID}
    />
)

export default VerticalSpacer
